/**
 * Super basic gql tagged template.
 *
 * Since we don't use an actual GraphQL client, this is good enough to generate
 * types with and just returns the query string
 *
 * @see package.json > scripts > graphql:codegen
 */
export const gql = (template: TemplateStringsArray, ...args: string[]) => {
  return template.reduce((acc, str, i) => acc + str + (args[i] ?? ''), '');
};
